import React, { Fragment, useState } from 'react';
import { useAnalytics } from '@Shared/useAnalytics';
import MenuLine from '@Shared/MenuLine';
import {
  MenuButton,
  MenuTitle,
  MenuWrapper,
  OutsideClickWrapper,
  StyledArrowDropDown,
  StyledButton,
  StyledDropDown
} from './About.styles';

const About = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { trackEvent, trackEventAndGo } = useAnalytics();

  const handleClickLink = (ev, name) => {
    trackEventAndGo(ev, 'clicked about carvana link', { platform: 'desktop', link: name });
  };

  const handleOpenDropdown = () => {
    setIsOpen(true);
    trackEvent('user platform - header - expanded about carvana', { platform: 'desktop' });
  };

  return (
    <Fragment>
      <MenuWrapper
        isDropdownExpanded={isOpen}
        onMouseEnter={handleOpenDropdown}
        onMouseLeave={() => setIsOpen(false)}
      >
        <MenuButton onTouchStart={() => setIsOpen(!isOpen)} disableHref>
          <MenuTitle isDropdownExpanded={isOpen}>About Carvana</MenuTitle>
          <StyledArrowDropDown isDropdownExpanded={isOpen} />
        </MenuButton>
        <StyledDropDown isDropdownExpanded={isOpen} aria-label="About Carvana">
          <StyledButton onClick={e => handleClickLink(e, 'About Us')} href="/about-us" target="_self">
            About Us
          </StyledButton>
          <MenuLine />
          <StyledButton onClick={e => handleClickLink(e, 'Customer Reviews')} href="/reviews" target="_self">
            Customer Reviews
          </StyledButton>
          <MenuLine />
          <StyledButton onClick={e => handleClickLink(e, 'Careers')} href="/careers" target="_self">
            Careers
          </StyledButton>
        </StyledDropDown>
      </MenuWrapper>
      <OutsideClickWrapper isDropdownExpanded={isOpen} onTouchStart={() => setIsOpen(false)} />
    </Fragment>
  );
};

export default About;
